import React, {Suspense, lazy} from 'react'
import Loader from '../Loader'

const Row = lazy(() => import('../Row'))
const InputField = lazy(() => import('../InputField'))
const SelectField = lazy(() => import('../SelectField'))
const RowHeader = lazy(() => import('../RowHeader'))
const Demographic = lazy(() => import('../../containers/Demographic'))
const Entitydetails = lazy(() => import('../../containers/Entitydetails'))
const EDDetails = lazy(() => import('../../containers/EmergencyDepartment/EDDetails'))
const Clinicians = lazy(() => import('../../containers/Clinicians'))
const PasswordField = lazy(() => import('../PasswordField'))
const ViewPlans = lazy(() => import('../ViewPlans'))
const StateCityZip = lazy(() => import('../StateCityZip'))
const Contact = lazy(() => import('../../containers/Contact'))
const TinInformation = lazy(() => import('../../containers/TinInformation'))
const MarkdownRender = lazy(() => import('../MarkdownRender'))
const RadioSelection = lazy(() => import('../RadioSelection'))
const AutoCompleteField = lazy(() => import('../AutoCompleteField'))
const Reporting = lazy(() => import('../../containers/Reporting'))
const RegistryQuestion = lazy(() => import('../../containers/RegistryQuestion'))
const Agreement = lazy(() => import('../../containers/Agreement/Agreements'))
const UploadBuilder = lazy(() => import('../UploadFile'))
const CheckBox = lazy(() => import('../CheckBox'))
const SwitchButton = lazy(() => import('../Switch/Switch'))
const MultiSpecialtyAuthorization = lazy(() =>
    import('../../containers/MultiSpecialtyAuthorization')
)
const ClinicianNPI = lazy(() => import('../ClinicianNPI'))
const Locations = lazy(() => import('../../containers/Location'))
const DatePicker = lazy(() => import('../DatePicker'))
const Cardboard = lazy(() => import('../Cardboard/Cardboard'))
const ReactSelect = lazy(() => import('../ReactSelect/ReactSelect'))
const MyAccountReactSelect = lazy(() =>
    import('../MyAccountReactSelect/MyAccountReactSelect')
)
const Payment = lazy(() => import('../../containers/Payment'))
const PaymentABFM = lazy(() => import('../../containers/PaymentABFM'))
const Phone = lazy(() => import('../Phone'))
const AmountLabels = lazy(() => import('../AmountLabels'))
const Border = lazy(() => import('../Border'))
const CreditCardInput = lazy(() => import('../CreditCardInput'))
const InnerExpansionPanel = lazy(() => import('../InnerExpansionPanel'))
const HorizontalChain = lazy(() => import('../../myAccount/components/HorizontalChain'))
const AccountCard = lazy(() => import('../../myAccount/components/AccountCard'))
const MyAccountRadioDropdown = lazy(() =>
    import('../MyAccountRadioDropdown/MyAccountRadioDropdown')
)
const Zipcode = lazy(() => import('../Zipcode'))

const Default = () => {
    return <span>Please check schema, could not render this component properly</span>
}

const ComponentSelector = props => {
    const components = {
        Row: Row,
        RowHeader: RowHeader,
        MarkdownRender: MarkdownRender,
        InputField: InputField,
        SelectField: SelectField,
        Demographic: Demographic,
        Entitydetails: Entitydetails,
        Clinicians: Clinicians,
        PasswordField: PasswordField,
        ViewPlans: ViewPlans,
        Contact: Contact,
        StateCityZip: StateCityZip,
        TinInformation: TinInformation,
        Default: Default,
        RadioSelection: RadioSelection,
        AutoCompleteField: AutoCompleteField,
        Reporting: Reporting,
        RegistryQuestion: RegistryQuestion,
        AgreementInformation: Agreement,
        UploadBuilder: UploadBuilder,
        CheckBox: CheckBox,
        SwitchButton: SwitchButton,
        MultiSpecialtyAuthorization: MultiSpecialtyAuthorization,
        ClinicianNPI: ClinicianNPI,
        Locations: Locations,
        DatePicker: DatePicker,
        Cardboard: Cardboard,
        ReactSelect: ReactSelect,
        Payment: Payment,
        PaymentABFM: PaymentABFM,
        Phone: Phone,
        AmountLabels: AmountLabels,
        Border: Border,
        CreditCardInput: CreditCardInput,
        InnerExpansionPanel: InnerExpansionPanel,
        EDDetails: EDDetails,
        HorizontalChain: HorizontalChain,
        AccountCard: AccountCard,
        MyAccountReactSelect: MyAccountReactSelect,
        MyAccountRadioDropdown: MyAccountRadioDropdown,
        Zipcode: Zipcode,
    }
    const ComponentName =
        components[props.componentType || 'Default'] || components['Default']

    return (
        <Suspense fallback={<Loader type="page" />}>
            <ComponentName {...props} />
        </Suspense>
    )
}

export default ComponentSelector
